module.exports = __webpack_public_path__ + "img/structureCopieAgap.9e19722a.png";